import {
  HOLIDAYS_FETCH_ERROR,
  HOLIDAYS_FETCH_LOADING,
  HOLIDAYS_FETCH_SUCCESS,
  HOLIDAYS_DELETE_SUCCESS,
  HOLIDAYS_DELETE_ERROR,
  HOLIDAYS_ADD_LOADING,
  HOLIDAYS_ADD_SUCCESS,
  HOLIDAYS_ADD_ERROR,
  HOLIDAYS_UPDATE_LOADING,
  HOLIDAYS_UPDATE_SUCCESS,
  HOLIDAYS_UPDATE_ERROR,
  HOLIDAYS_GET_SUCCESS,
  HOLIDAYS_GET_ERROR,
  HOLIDAYS_GET_LOADING,
  UPCOMING_HOLIDAYS_FETCH_SUCCESS,
  UPCOMING_HOLIDAYS_FETCH_LOADING,
  UPCOMING_HOLIDAYS_FETCH_ERROR,
  RESET_RESULT,
  RESET_MESSAGES,
} from "../types";

const initialState = {
  loading: false,
  page_loading: false,
  result: [],
  error: "",
  addUpdateHolidayError: "",
  holidayDeleteMessage: "",
  holidayUpdateMessage: "",
};

const holidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case HOLIDAYS_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case HOLIDAYS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case HOLIDAYS_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case UPCOMING_HOLIDAYS_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case UPCOMING_HOLIDAYS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case UPCOMING_HOLIDAYS_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case HOLIDAYS_DELETE_SUCCESS:
      return {
        ...state,
        holidayDeleteMessage: action.payload,
      };
    case HOLIDAYS_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HOLIDAYS_ADD_LOADING:
      return {
        ...state,
        loading: action.payload,
        addUpdateHolidayError: "",
      };
    case HOLIDAYS_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case HOLIDAYS_ADD_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        addUpdateHolidayError: action.payload,
      };
    case HOLIDAYS_UPDATE_LOADING:
      return {
        ...state,
        loading: action.payload,
        addUpdateHolidayError: "",
      };
    case HOLIDAYS_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        holidayUpdateMessage: action.payload,
      };
    case HOLIDAYS_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        addUpdateHolidayError: action.payload,
      };
    case HOLIDAYS_GET_LOADING:
      return {
        ...state,
        page_loading: action.payload,
        loading: action.payload,
      };
    case HOLIDAYS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        page_loading: false,
        result: action.payload,
      };
    case HOLIDAYS_GET_ERROR:
      return {
        ...state,
        loading: false,
        page_loading: false,
        result: [],
        error: action.payload,
      };
    case RESET_RESULT:
      return {
        ...state,
        loading: false,
        result: [],
        error: "",
        holidayDeleteMessage: "",
        holidayUpdateMessage: "",
        addUpdateHolidayError: "",
      };
    case RESET_MESSAGES:
      return {
        ...state,
        error: "",
        holidayDeleteMessage: "",
        holidayUpdateMessage: "",
        addUpdateHolidayError: "",
      };

    default:
      return state;
  }
};

export default holidayReducer;
